import React, {memo, useCallback, useState} from 'react';
import {NavLink} from 'react-router-dom';
// import {billingNav, billingMobileNav} from '../../assets/images/images';

import * as Icons from '../../assets/images/images';
import {Constants} from '../../helpers';
import {usePermissions} from '../../hooks/useSidbarPermissions';
import {
  NavigationItem,
  SubNavigationDropdown,
  SubNavigationItem,
} from './components';
import {reconciloNavLinks} from './constants';
import {RequestAccessModal} from '../RequestAccessModal';
import {
  AddressVerification,
  AmlScreening,
  ApiStatus,
  BaaS,
  Billing,
  // Cases,
  Customers,
  CustomLists,
  Developers,
  DocumentAnalysis,
  EasyAuth,
  EasyCreditCheck,
  EasyDetect,
  // EasyDetectReport,
  EasyOnboard,
  GovernmentLookup,
  Logs,
  MessagingLogs,
  QuickActionsIcon,
  Reconciliation,
  Settings,
  ApiAnalysis,
} from 'components/images/sidebar';

const MainSideNavigations = memo(
  ({media, splitLocation, pathname, openDropdown, toggleSubRoute}) => {
    const [resourceName, setResourceName] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const {modularisation: module, ...rest} = usePermissions();
    const [hoveredDropdown, setHoveredDropdown] = useState({});

    const requestAccess = useCallback(
      args => {
        const isInternalAccess = !args?.resourceModule;

        return isInternalAccess
          ? {
              onClick: data => {
                args?.callback(data);
                setResourceName(args?.resourceName);
              },
              toggleSubRoute: data => {
                args?.callback(data);
                setResourceName(args?.resourceName);
              },
              active: null,
              open: null,
              to: Constants.PAGES_URL[args?.route],
              isEnabled: 'hidden',
            }
          : {
              ...(args?.dropdown
                ? {
                    open: openDropdown === args?.dropdown,

                    toggleSubRoute: args?.toggleSubRoute,
                  }
                : {
                    to: Constants.PAGES_URL[args?.route],
                    active: args?.activeState || splitLocation[1] === '',
                  }),
            };
      },
      [openDropdown, splitLocation],
    );

    const customerPool =
      module?.aml_screening_services ||
      module?.easy_lookup_services ||
      module?.easy_onboard_services ||
      module?.document_analysis;

    const handleHoverChange = (dropdownKey, isHovered) => {
      setHoveredDropdown(prev => ({
        ...prev,
        [dropdownKey]: isHovered,
      }));
    };

    return (
      <>
        <div className="flex flex-col">
          <NavigationItem
            media={media}
            title="Quick Actions"
            IconComponent={QuickActionsIcon}
            {...requestAccess({
              resourceModule: module.quick_actions_services,
              resourceName: '',
              route: 'QUICKACTIONS',
              callback: () => setIsModalOpen(true),
            })}
            // isEnabled="hidden"
          />

          <RequestAccessModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            resourceName={resourceName}
          />

          {customerPool && (
            <div className="flex flex-col  rounded lg:text-white text-grey">
              <SubNavigationDropdown
                media={media}
                IconComponent={Customers}
                label="Customers"
                subRoutes={[
                  Constants.PAGES_URL.CUSTOMER_360,
                  Constants.PAGES_URL.BUSINESS_360,
                ]}
                isChildHovered={hoveredDropdown['customer']}
                {...requestAccess({
                  resourceModule: customerPool,
                  resourceName: '',
                  dropdown: 'customer',
                  callback: () => setIsModalOpen(true),
                  toggleSubRoute: () => toggleSubRoute('customer'),
                })}
              />

              {openDropdown === 'customer' && (
                <div className="flex flex-col">
                  <SubNavigationItem
                    title="Individual"
                    active={splitLocation[1] === ''}
                    to={Constants.PAGES_URL.CUSTOMER_360}
                    onHoverChange={isHovered =>
                      handleHoverChange('customer', isHovered)
                    }
                  />
                  <SubNavigationItem
                    className="rounded-b-lg"
                    title=" Business"
                    active={splitLocation[1] === ''}
                    to={Constants.PAGES_URL.BUSINESS_360}
                    onHoverChange={isHovered =>
                      handleHoverChange('customer', isHovered)
                    }
                  />
                </div>
              )}
            </div>
          )}
        </div>
        <div className="flex flex-col">
          {(rest?.permittedLinks(rest?.USER_PERMISSIONS?.lookupPermissions) ||
            rest?.permittedLinks(rest?.USER_PERMISSIONS?.onboardPermissions) ||
            rest?.permittedLinks(
              rest?.USER_PERMISSIONS?.documentAnalysisPermissions,
            ) ||
            rest?.permittedLinks(
              rest?.USER_PERMISSIONS?.addressVerificationPermissions,
            )) && (
            <p className="text-xs text-[#5C688E] py-4 pl-3 uppercase tracking-[0.04em]">
              identity verification
            </p>
          )}

          {
            <div className="flex flex-col">
              <div className="flex flex-col  rounded lg:text-white text-grey">
                <div className="flex flex-col ">
                  {rest?.permittedLinks(
                    rest?.USER_PERMISSIONS?.lookupPermissions,
                  ) && (
                    <NavigationItem
                      media={media}
                      title="Government Lookup"
                      IconComponent={GovernmentLookup}
                      {...requestAccess({
                        resourceModule: module.easy_lookup_services,
                        resourceName: 'easy_lookup_services',
                        route: 'INDIVIDUAL_LOOKUP',
                        callback: () => setIsModalOpen(true),
                      })}
                    />
                  )}

                  {rest?.permittedLinks(
                    rest?.USER_PERMISSIONS?.onboardPermissions,
                  ) &&
                    module.easy_onboard_services && (
                      <div className="flex flex-col rounded lg:text-white text-grey">
                        <SubNavigationDropdown
                          media={media}
                          IconComponent={EasyOnboard}
                          label="EasyOnboard"
                          subRoutes={[
                            Constants.PAGES_URL.EASY_ONBOARD,
                            Constants.PAGES_URL.VERIFICATIONS,
                            Constants.PAGES_URL.VERIFICATION_ANALYTICS,
                          ]}
                          isChildHovered={hoveredDropdown['easy-onboard']}
                          {...requestAccess({
                            resourceModule: module.easy_onboard_services,
                            resourceName: 'easy_onboard_services',
                            dropdown: 'easy-onboard',
                            callback: () => setIsModalOpen(true),
                            toggleSubRoute: () =>
                              toggleSubRoute('easy-onboard'),
                          })}
                        />
                      </div>
                    )}

                  {openDropdown === 'easy-onboard' && (
                    <div className="flex flex-col">
                      {rest?.permittedLinks(
                        rest?.USER_PERMISSIONS?.onboardPermissions,
                      ) && (
                        <SubNavigationItem
                          media={media}
                          title="Verification flow"
                          onHoverChange={isHovered =>
                            handleHoverChange('easy-onboard', isHovered)
                          }
                          {...requestAccess({
                            resourceModule: module.easy_onboard_services,
                            resourceName: 'easy_onboard_services',
                            route: 'EASY_ONBOARD',
                            callback: () => setIsModalOpen(true),
                          })}
                        />
                      )}

                      {rest?.canViewIdVerification ? (
                        <SubNavigationItem
                          media={media}
                          title="Verifications"
                          onHoverChange={isHovered =>
                            handleHoverChange('easy-onboard', isHovered)
                          }
                          {...requestAccess({
                            resourceModule:
                              module.id_verification_services ||
                              module.easy_onboard_services,
                            resourceName: '',
                            route: 'VERIFICATIONS',
                            callback: () => setIsModalOpen(true),
                          })}
                        />
                      ) : null}

                      {rest?.canViewIdVerification ? (
                        <SubNavigationItem
                          media={media}
                          className="rounded-b-lg"
                          title="Verifications Analytics"
                          onHoverChange={isHovered =>
                            handleHoverChange('easy-onboard', isHovered)
                          }
                          {...requestAccess({
                            resourceModule:
                              module.id_verification_services ||
                              module.easy_onboard_services,
                            resourceName: '',
                            route: 'VERIFICATION_ANALYTICS',
                            callback: () => setIsModalOpen(true),
                          })}
                        />
                      ) : null}
                    </div>
                  )}
                </div>
              </div>

              {rest?.permittedLinks(
                rest?.USER_PERMISSIONS?.documentAnalysisPermissions,
              ) && (
                <NavigationItem
                  media={media}
                  title="Document Analysis"
                  IconComponent={DocumentAnalysis}
                  {...requestAccess({
                    resourceModule: module.document_analysis,
                    resourceName: 'document_analysis',
                    route: 'DOCUMENT_ANALYSIS',
                    callback: () => setIsModalOpen(true),
                  })}
                />
              )}

              {module?.easy_auth_services && (
                <div className="flex flex-col  rounded lg:text-white text-grey">
                  <SubNavigationDropdown
                    media={media}
                    IconComponent={EasyAuth}
                    label="EasyAuthentication"
                    subRoutes={[
                      Constants.PAGES_URL.AUTHENTICATION_FLOW,
                      Constants.PAGES_URL.AUTHENTICATIONS,
                      Constants.PAGES_URL.AUTHENTICATION_CUSTOMERS,
                    ]}
                    isChildHovered={hoveredDropdown['easy-authentication']}
                    {...requestAccess({
                      resourceModule: module?.easy_auth_services,
                      resourceName: '',
                      dropdown: 'easy-authentication',
                      callback: () => setIsModalOpen(true),
                      toggleSubRoute: () =>
                        toggleSubRoute('easy-authentication'),
                    })}
                  />

                  {openDropdown === 'easy-authentication' && (
                    <div className="flex flex-col">
                      <SubNavigationItem
                        media={media}
                        title="Authentication Flow"
                        active={splitLocation[1] === ''}
                        to={Constants.PAGES_URL.AUTHENTICATION_FLOW}
                        webIcon={Icons.authenticationFlow}
                        mobileIcon={Icons.easyAuthenticationMobile}
                        inner
                      />
                      <SubNavigationItem
                        media={media}
                        title="Authentications"
                        active={splitLocation[1] === ''}
                        to={Constants.PAGES_URL.AUTHENTICATIONS}
                        webIcon={Icons.authentications}
                        mobileIcon={Icons.authentications}
                        inner
                      />
                      <SubNavigationItem
                        media={media}
                        title="Customers"
                        active={splitLocation[1] === ''}
                        to={Constants.PAGES_URL.AUTHENTICATION_CUSTOMERS}
                        webIcon={Icons.usersNav}
                        mobileIcon={Icons.usersNav}
                        inner
                      />
                    </div>
                  )}
                </div>
              )}

              {rest?.permittedLinks(
                rest?.USER_PERMISSIONS?.addressVerificationPermissions,
              ) && (
                <NavigationItem
                  media={media}
                  title="Address Verification"
                  IconComponent={AddressVerification}
                  {...requestAccess({
                    resourceModule: module.address_verification_services,
                    resourceName: 'address_verification_services',
                    route: 'ADDRESS_VERIFICATION',
                    callback: () => setIsModalOpen(true),
                  })}
                />
              )}
            </div>
          }
        </div>

        <p className="text-xs text-[#5C688E] py-4 pl-3 uppercase tracking-[0.04em]">
          FRAUD MONITORING
        </p>

        <div className="flex flex-col">
          {rest?.permittedLinks(
            rest?.USER_PERMISSIONS?.amlScreeningPermissions,
          ) && (
            <NavigationItem
              media={media}
              title="AML Screening"
              IconComponent={AmlScreening}
              {...requestAccess({
                resourceModule: module.aml_screening_services,
                resourceName: '',
                route: 'AML_SCREENING',
                callback: () => setIsModalOpen(true),
              })}
            />
          )}

          {rest?.canViewReconciliation && module.reconciliation && (
            <div className="flex flex-col  rounded lg:text-white text-grey">
              <SubNavigationDropdown
                media={media}
                IconComponent={Reconciliation}
                label="Reconciliation"
                subRoutes={[
                  Constants.PAGES_URL.PROJECT_ACCOUNTS,
                  Constants.PAGES_URL.PROJECT_TRANSACTIONS,
                  Constants.PAGES_URL.PROJECT_RECONCILIATION,
                  Constants.PAGES_URL.PROJECT_CUSTOMERS,
                  Constants.PAGES_URL.PROJECT_SETTINGS,
                ]}
                isChildHovered={hoveredDropdown['reconciliation']}
                {...requestAccess({
                  resourceModule: module.reconciliation,
                  resourceName: 'reconciliation',
                  dropdown: 'reconciliation',
                  callback: () => setIsModalOpen(true),
                  toggleSubRoute: () => toggleSubRoute('reconciliation'),
                })}
              />

              {openDropdown === 'reconciliation' && (
                <div className="flex flex-col">
                  {reconciloNavLinks?.map((link, idx) => (
                    <SubNavigationItem
                      key={link?.label + idx}
                      media={media}
                      title={link?.label}
                      active={splitLocation[1] === ''}
                      to={link?.url.replace(':slug', rest?.projectId)}
                      onHoverChange={isHovered =>
                        handleHoverChange('reconciliation', isHovered)
                      }
                      className={
                        idx === reconciloNavLinks.length - 1
                          ? 'rounded-b-lg'
                          : ''
                      }
                    />
                  ))}
                </div>
              )}
            </div>
          )}

          {(rest?.reviewCases || rest?.manageDetectFlows) &&
            module.easy_detect_services && (
              <div className="flex flex-col  rounded lg:text-white text-grey">
                <SubNavigationDropdown
                  media={media}
                  IconComponent={EasyDetect}
                  label="EasyDetect"
                  subRoutes={[
                    Constants.PAGES_URL.FLOW_TEMPLATES,
                    Constants.PAGES_URL.FLOWS,
                    Constants.PAGES_URL.ACCOUNTS,
                    Constants.PAGES_URL.OVERVIEW_PENDING_CASES,
                  ]}
                  isChildHovered={hoveredDropdown['easy-detect']}
                  {...requestAccess({
                    resourceModule: module.easy_detect_services,
                    resourceName: 'easy_detect_services',
                    dropdown: 'easy-detect',
                    callback: () => setIsModalOpen(true),
                    toggleSubRoute: () => toggleSubRoute('easy-detect'),
                  })}
                />

                {openDropdown === 'easy-detect' && (
                  <div className="flex flex-col">
                    {/*{manageDetectFlows && (*/}
                    {/*  <NavigationItem*/}
                    {/*    media={media}*/}
                    {/*    title="Overview"*/}
                    {/*    active={splitLocation[1] === ''}*/}
                    {/*    to={Constants.PAGES_URL.OVERVIEW}*/}
                    {/*    webIcon={overviewNav}*/}
                    {/*    mobileIcon={overviewMobileNav}*/}
                    {/*    inner*/}
                    {/*  />*/}
                    {/*)}*/}
                    {/*{rest?.canManageFlows && rest?.manageDetectFlows && (*/}
                    <SubNavigationItem
                      media={media}
                      title="Overview"
                      active={splitLocation[1] === ''}
                      to={Constants.PAGES_URL.PROFILED_RISK_OVERVIEW}
                      onHoverChange={isHovered =>
                        handleHoverChange('easy-detect', isHovered)
                      }
                    />
                    <SubNavigationItem
                      media={media}
                      title="Profiles"
                      active={splitLocation[1] === ''}
                      to={Constants.PAGES_URL.PROFILED_RISK_PROFILES}
                      onHoverChange={isHovered =>
                        handleHoverChange('easy-detect', isHovered)
                      }
                    />
                    <SubNavigationItem
                      media={media}
                      title="Events"
                      active={splitLocation[1] === ''}
                      to={Constants.PAGES_URL.PROFILED_RISK_EVENTS}
                      onHoverChange={isHovered =>
                        handleHoverChange('easy-detect', isHovered)
                      }
                    />
                    {/*)}*/}
                    {/*<SubNavigationItem*/}
                    {/*  media={media}*/}
                    {/*  title="Flow Templates"*/}
                    {/*  active={splitLocation[1] === ''}*/}
                    {/*  to={Constants.PAGES_URL.FLOW_TEMPLATES}*/}
                    {/*  onHoverChange={isHovered =>*/}
                    {/*    handleHoverChange('easy-detect', isHovered)*/}
                    {/*  }*/}
                    {/*/>*/}

                    {rest?.canManageFlows && rest?.manageDetectFlows && (
                      <SubNavigationItem
                        media={media}
                        title="Manage Flows"
                        active={splitLocation[1] === ''}
                        to={Constants.PAGES_URL.FLOWS}
                        onHoverChange={isHovered =>
                          handleHoverChange('easy-detect', isHovered)
                        }
                      />
                    )}
                    <SubNavigationItem
                      media={media}
                      title="Configuration"
                      className="rounded-b-lg"
                      onHoverChange={isHovered =>
                        handleHoverChange('easy-detect', isHovered)
                      }
                      to={Constants.PAGES_URL.PROFILED_RISK_CONFIGURATION}
                    />
                    {rest?.canReviewCases && rest?.reviewCases && (
                      <SubNavigationItem
                        className="rounded-b-lg"
                        media={media}
                        title="Pending Cases"
                        active={splitLocation[1] === ''}
                        to={Constants.PAGES_URL.OVERVIEW_PENDING_CASES}
                        onHoverChange={isHovered =>
                          handleHoverChange('easy-detect', isHovered)
                        }
                      />
                    )}
                  </div>
                )}
              </div>
            )}
        </div>
        <div className="flex flex-col">
          <NavigationItem
            media={media}
            title="Custom Lists"
            IconComponent={CustomLists}
            {...requestAccess({
              resourceModule: module.custom_link,
              resourceName: '',
              route: 'CUSTOM_LISTS',
              callback: () => setIsModalOpen(true),
            })}
          />

          <NavigationItem
            media={media}
            title="Easy Credit Check"
            IconComponent={EasyCreditCheck}
            {...requestAccess({
              resourceModule: module.credit_check_services,
              resourceName: 'credit_check_services',
              route: 'EASY_CREDIT_CHECK',
              callback: () => setIsModalOpen(true),
            })}
          />
        </div>
        {rest?.permittedLinks(rest?.USER_PERMISSIONS?.baasPermissions) &&
          module.baas && (
            <p className="text-xs text-[#5C688E] py-4 pl-3 uppercase tracking-[0.04em]">
              FINANCIAL SERVICES
            </p>
          )}
        {rest?.permittedLinks(rest?.USER_PERMISSIONS?.baasPermissions) &&
          module.baas && (
            <div className="flex flex-col  rounded lg:text-white text-grey">
              <SubNavigationDropdown
                media={media}
                IconComponent={BaaS}
                label="BAAS"
                subRoutes={[
                  Constants.PAGES_URL.BAAS_OVERVIEW,
                  Constants.PAGES_URL.BAAS_CUSTOMERS,
                  Constants.PAGES_URL.BAAS_TRANSACTIONS,
                  Constants.PAGES_URL.BAAS_WALLETS,
                  Constants.PAGES_URL.BAAS_PAYOUTS,
                  Constants.PAGES_URL.BAAS_SETTINGS,
                ]}
                isChildHovered={hoveredDropdown['baas']}
                {...requestAccess({
                  resourceModule: module.baas,
                  resourceName: '',
                  dropdown: 'baas',
                  callback: () => setIsModalOpen(true),
                  toggleSubRoute: () => toggleSubRoute('baas'),
                })}
              />

              {openDropdown === 'baas' && (
                <div className="flex flex-col">
                  {rest?.baasPagePermissions?.canViewOverview && (
                    <SubNavigationItem
                      media={media}
                      title="Overview"
                      active={splitLocation[1] === ''}
                      to={Constants.PAGES_URL.BAAS_OVERVIEW}
                      webIcon={Icons?.baasOverview}
                      mobileIcon={Icons?.baasOverview}
                      inner
                    />
                  )}
                  <SubNavigationItem
                    media={media}
                    title="Customers"
                    active={splitLocation[1] === ''}
                    to={Constants.PAGES_URL.BAAS_CUSTOMERS}
                    onHoverChange={isHovered =>
                      handleHoverChange('baas', isHovered)
                    }
                  />
                  {rest?.baasPagePermissions?.canViewTransactions && (
                    <SubNavigationItem
                      media={media}
                      title="Transactions"
                      active={splitLocation[1] === ''}
                      to={Constants.PAGES_URL.BAAS_TRANSACTIONS}
                      onHoverChange={isHovered =>
                        handleHoverChange('baas', isHovered)
                      }
                    />
                  )}
                  {rest?.baasPagePermissions?.canViewWallets && (
                    <SubNavigationItem
                      media={media}
                      title="Wallets"
                      active={splitLocation[1] === ''}
                      to={Constants.PAGES_URL.BAAS_WALLETS}
                      onHoverChange={isHovered =>
                        handleHoverChange('baas', isHovered)
                      }
                    />
                  )}
                  {rest?.baasPagePermissions?.canViewPayouts && (
                    <SubNavigationItem
                      media={media}
                      title="Payouts"
                      active={splitLocation[1] === ''}
                      to={Constants.PAGES_URL.BAAS_PAYOUTS}
                      onHoverChange={isHovered =>
                        handleHoverChange('baas', isHovered)
                      }
                    />
                  )}
                  {rest?.baasPagePermissions?.canManageSettings && (
                    <SubNavigationItem
                      className="rounded-b-lg"
                      media={media}
                      title="BAAS Settings"
                      active={splitLocation[1] === ''}
                      to={Constants.PAGES_URL.BAAS_SETTINGS}
                      onHoverChange={isHovered =>
                        handleHoverChange('baas', isHovered)
                      }
                    />
                  )}
                </div>
              )}
            </div>
          )}

        {Object.values(
          rest?.USER_PERMISSIONS?.analyticsPermissions || {},
        )?.every(s => s) &&
          module.messaging_report_services && (
            <p className="text-xs text-[#5C688E] py-4 pl-3 uppercase tracking-[0.04em]">
              REPORT ANALYTICS
            </p>
          )}
        <div className="flex flex-col">
          {/*{(USER_PERMISSIONS?.analyticsPermissions?.viewApi ||*/}
          {/*  USER_PERMISSIONS?.analyticsPermissions?.exportApi) &&*/}
          {/*  api_report_services && (*/}
          {/*    <NavigationItem*/}
          {/*      media={media}*/}
          {/*      title="API Report"*/}
          {/*      active={splitLocation[1] === ''}*/}
          {/*      to={Constants.PAGES_URL.API_REPORT}*/}
          {/*      webIcon={apiReportNav}*/}
          {/*      mobileIcon={apiReportMobileNav}*/}
          {/*    />*/}
          {/*  )}*/}
          {(rest?.USER_PERMISSIONS?.analyticsPermissions?.viewMessaging ||
            rest?.USER_PERMISSIONS?.analyticsPermissions?.exportMessaging) && (
            <NavigationItem
              media={media}
              title="Messaging Logs"
              IconComponent={MessagingLogs}
              {...requestAccess({
                resourceModule: module.messaging_report_services,
                resourceName: '',
                route: 'MESSAGING_REPORT',
                callback: () => setIsModalOpen(true),
              })}
            />
          )}
          {/* {(rest?.USER_PERMISSIONS?.analyticsPermissions?.viewEasyDetect ||
            rest?.USER_PERMISSIONS?.analyticsPermissions?.exportEasyDetect) && (
            <NavigationItem
              media={media}
              title="Easy Detect Report"
              IconComponent={EasyDetectReport}
              {...requestAccess({
                resourceModule: module.easy_detect_report_services,
                resourceName: '',
                route: 'EASY_DETECT_REPORT',
                callback: () => setIsModalOpen(true),
              })}
            />
          )} */}
        </div>
        {rest?.permittedLinks(rest?.USER_PERMISSIONS?.developerPermissions) &&
          module.developers_services && (
            <div className="mt-6 flex flex-col  rounded lg:text-white text-grey">
              <SubNavigationDropdown
                media={media}
                IconComponent={Developers}
                label="Developers"
                subRoutes={[
                  Constants.PAGES_URL.DEVELOPERS_API_LOGS,
                  Constants.PAGES_URL.DEVELOPERS_CONFIGURATION,
                  Constants.PAGES_URL.DEVELOPERS_WEBHOOK,
                  Constants.PAGES_URL.API_TOKENS,
                ]}
                isChildHovered={hoveredDropdown['developers']}
                {...requestAccess({
                  resourceModule: module.developers_services,
                  resourceName: '',
                  dropdown: 'developers',
                  callback: () => setIsModalOpen(true),
                  toggleSubRoute: () => toggleSubRoute('developers'),
                })}
              />

              {openDropdown === 'developers' && (
                <div className="flex flex-col">
                  {rest?.canViewApiLogs && (
                    <SubNavigationItem
                      media={media}
                      title="API Logs"
                      webIcon={Icons.apiLogsNav}
                      mobileIcon={Icons.apiLogsMobileNav}
                      inner
                      {...requestAccess({
                        resourceModule: module.api_logs_services,
                        resourceName: '',
                        route: 'DEVELOPERS_API_LOGS',
                        callback: () => setIsModalOpen(true),
                      })}
                    />
                  )}
                  {rest?.permittedLinks(
                    rest?.USER_PERMISSIONS?.developerPermissions,
                  ) && (
                    <SubNavigationItem
                      media={media}
                      title="Configuration"
                      active={splitLocation[1] === ''}
                      to={Constants.PAGES_URL.DEVELOPERS_CONFIGURATION}
                      onHoverChange={isHovered =>
                        handleHoverChange('developers', isHovered)
                      }
                    />
                  )}

                  {rest?.canManageTokens && (
                    <SubNavigationItem
                      media={media}
                      title="API Tokens"
                      active={splitLocation[1] === ''}
                      to={Constants.PAGES_URL.API_TOKENS}
                      onHoverChange={isHovered =>
                        handleHoverChange('developers', isHovered)
                      }
                    />
                  )}
                  {rest?.webhookPermission && (
                    <SubNavigationItem
                      media={media}
                      title="Webhooks"
                      active={splitLocation[1] === ''}
                      to={Constants.PAGES_URL.DEVELOPERS_WEBHOOK}
                      onHoverChange={isHovered =>
                        handleHoverChange('developers', isHovered)
                      }
                    />
                  )}
                  {!module.is_partner_company && (
                    <a
                      href="https://api-docs.dojah.io/"
                      target="_blank"
                      rel="noreferrer"
                      className={`rounded-b-lg lg:text-white text-grey hover:bg-[#212b63] flex items-center h-[38px] bg-[#161b40] gap-2 pl-8 lg:pl-[38px] pr-2 py-2 relative ${splitLocation[1]} === "" ? "active" : ""`}
                    >
                      <span className="text-sm lg:text-white text-grey -mb-1 mr-[7px]">
                        Documentation
                      </span>
                      <img
                        src={media ? Icons.hyperLinkWhite : Icons.hyperLinkGrey}
                        alt=""
                        width={14}
                        height={14}
                      />
                    </a>
                  )}
                </div>
              )}
            </div>
          )}

        {(rest?.canViewHistory || rest?.canViewApiCalls) &&
          module.billings_services && (
            <div className="flex flex-col  rounded lg:text-white text-grey">
              <SubNavigationDropdown
                media={media}
                IconComponent={Billing}
                label="Billings"
                subRoutes={[
                  Constants.PAGES_URL.SETTINGS_BILLING,
                  Constants.PAGES_URL.SETTINGS_BILLING_PRICING,
                ]}
                isChildHovered={hoveredDropdown['billing']}
                {...requestAccess({
                  resourceModule: module.billings_services,
                  resourceName: '',
                  dropdown: 'billing',
                  callback: () => setIsModalOpen(true),
                  toggleSubRoute: () => toggleSubRoute('billing'),
                })}
              />

              {openDropdown === 'billing' && (
                <div className="flex flex-col mb-2">
                  {rest?.canViewHistory && (
                    <SubNavigationItem
                      media={media}
                      title="Transaction history"
                      active={pathname === Constants.PAGES_URL.SETTINGS_BILLING}
                      to={Constants.PAGES_URL.SETTINGS_BILLING}
                      onHoverChange={isHovered =>
                        handleHoverChange('billing', isHovered)
                      }
                    />
                  )}
                  {rest?.canViewApiCalls && (
                    <SubNavigationItem
                      className="rounded-b-lg"
                      media={media}
                      title="API calls"
                      active={
                        pathname ===
                        Constants.PAGES_URL.SETTINGS_BILLING_PRICING
                      }
                      to={Constants.PAGES_URL.SETTINGS_BILLING_PRICING}
                      onHoverChange={isHovered =>
                        handleHoverChange('billing', isHovered)
                      }
                    />
                  )}

                  {(module.api_report_services ||
                    module.easy_detect_report_services) && (
                    <div className="flex flex-col">
                      <div className="flex-col hidden lg:flex"></div>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

        <NavigationItem
          media={media}
          title="API Analysis"
          active={splitLocation[1] === ''}
          to={Constants.PAGES_URL.API_ANALYSIS}
          IconComponent={ApiAnalysis}
        />

        {process.env.REACT_APP_APP_ENV_MODE !== 'production' && (
          <NavigationItem
            media={media}
            title="API Status"
            active={splitLocation[1] === ''}
            to={Constants.PAGES_URL.API_STATUS}
            IconComponent={ApiStatus}
          />
        )}

        {rest?.USER_PERMISSIONS?.settingsPermissions?.viewAndDownloadAudit &&
          rest?.manageAuditLogs && (
            <div>
              <NavigationItem
                media={media}
                title={<div className="flex items-center   gap-2">Logs</div>}
                active={
                  pathname === Constants.PAGES_URL.AUDIT_LOGS ||
                  pathname === Constants.PAGES_URL.EXPORT_LOGS
                }
                to={Constants.PAGES_URL.AUDIT_LOGS}
                IconComponent={Logs}
                {...requestAccess({
                  resourceModule: module.audit_logs_services,
                  resourceName: '',
                  route: 'AUDIT_LOGS',
                  callback: () => setIsModalOpen(true),
                })}
              />
            </div>
          )}

        <div className="flex flex-col">
          <SubNavigationDropdown
            media={media}
            IconComponent={Settings}
            label="Settings"
            subRoutes={[
              Constants.PAGES_URL.SETTINGS_PROFILE,
              Constants.PAGES_URL.SETTINGS_COMPANY_VERIFICATION,
              Constants.PAGES_URL.SETTINGS_ORGANISATION,
              Constants.PAGES_URL.SETTINGS_TEAM,
            ]}
            isChildHovered={hoveredDropdown['settings']}
            {...requestAccess({
              resourceModule: module.profile_services || module.teams_services,
              resourceName: '',
              dropdown: 'settings',
              callback: () => setIsModalOpen(true),
              toggleSubRoute: () => toggleSubRoute('settings'),
            })}
          />

          {openDropdown === 'settings' && (
            <>
              <NavLink
                to={Constants.PAGES_URL.SETTINGS_PROFILE}
                className={`nav-item rounded flex lg:hidden items-center  pl-8 py-2 relative ${splitLocation[1]} === "" ? "active" : ""`}
                aria-current="page"
              >
                <img
                  src={Icons.settingsMobileNav}
                  alt=""
                  width={18}
                  height={18}
                />
                <span className="-mb-1 text-sm text-body">All settings</span>
              </NavLink>
              <div className="flex-col hidden lg:flex">
                <SubNavigationItem
                  media={media}
                  title="Profile"
                  onHoverChange={isHovered =>
                    handleHoverChange('settings', isHovered)
                  }
                  {...requestAccess({
                    resourceModule: module.profile_services,
                    resourceName: '',
                    route: 'SETTINGS_PROFILE',
                    callback: () => setIsModalOpen(true),
                  })}
                />

                {rest.USER_PERMISSIONS.role === 'Owner' && (
                  <SubNavigationItem
                    media={media}
                    title="Company Verification"
                    onHoverChange={isHovered =>
                      handleHoverChange('settings', isHovered)
                    }
                    active={splitLocation[1] === ''}
                    to={Constants.PAGES_URL.SETTINGS_COMPANY_VERIFICATION}
                  />
                )}

                {Object.values(
                  rest?.USER_PERMISSIONS?.settingsPermissions || {},
                ).some(s => !!s) && (
                  <>
                    {rest?.USER_PERMISSIONS?.settingsPermissions
                      ?.manageMembers &&
                      rest?.managePermissions && (
                        <SubNavigationItem
                          media={media}
                          title="Team"
                          onHoverChange={isHovered =>
                            handleHoverChange('settings', isHovered)
                          }
                          {...requestAccess({
                            resourceModule: module.teams_services,
                            resourceName: '',
                            route: 'SETTINGS_TEAM',
                            callback: () => setIsModalOpen(true),
                          })}
                        />
                      )}

                    {/* {rest?.USER_PERMISSIONS?.role === 'Owner' && (
                      <SubNavigationItem
                        media={media}
                        title="Organisation"
                        active={
                          pathname === Constants.PAGES_URL.SETTINGS_ORGANISATION
                        }
                        to={Constants.PAGES_URL.SETTINGS_ORGANISATION}
                        onHoverChange={isHovered =>
                          handleHoverChange('settings', isHovered)
                        }
                      />
                    )} */}
                  </>
                )}

                {rest.USER_PERMISSIONS.role === 'Owner' && (
                  <SubNavigationItem
                    media={media}
                    className="rounded-b-lg"
                    title="Email Notifications"
                    onHoverChange={isHovered =>
                      handleHoverChange('settings', isHovered)
                    }
                    active={splitLocation[1] === ''}
                    to={Constants.PAGES_URL.SETTINGS_EMAIL_NOTIFICATIONS}
                  />
                )}
              </div>
            </>
          )}
        </div>
      </>
    );
  },
);

export {MainSideNavigations};
